const AboutMe = () => {
  return (
    <div id="aboutMe">
      <h1 className="about">
        <section>01.</section>About Me
      </h1>
      <div className="aboutMe container">
        <div className="aboutMe text">
          <div className="aboutMe intro">
            <p>
              Hi! My name is Nick Amenda, a full-stack software engineer who has a passion for exploring 
              the latest technologies and possibilities of coding. I thrive in dynamic environments where 
              I can continuously learn and innovate. My interest in software development began at my previous 
              role, where I discovered my deep interest in technology and problem-solving. This led me to 
              pursue a career in coding, where I have been for about 3 years now.
            </p>
            <p>
              Currently, I'm working full-time at a growing startup, where I enjoy the flexibility of working 
              with a wide range of technologies, programming languages, and systems. My role allows me to 
              contribute to building innovative solutions that streamline operations, improve efficiency, 
              and integrate complex systems.
            </p>
          </div>
          <div className="aboutMe exp">
            <p>
              When I'm not coding, you can find me working out, playing basketball, enjoying video games, 
              or spending quality time with friends. I believe in maintaining a healthy work-life balance 
              and constantly seeking new challenges that push me to grow both personally and professionally.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutMe;
